import type { BFFArticleBodyElement, BFFArticleCard } from "@src/app/types/bff";
import cx from "classnames";

import Link from "../../Link";
import OptimisedImage from "../../OptimisedImage/OptimisedImage";

export default function ArticleRelation({
  element,
  relationArticles = [],
}: {
  element: BFFArticleBodyElement["relation"];
  /** latest articles in Relation Element */
  relationArticles: BFFArticleCard[];
}) {
  const article = relationArticles.find((i) => i.id === element.id);
  if (!article) return null;

  return (
    <Link to={`${article.urlPath || ""}?ref=article-in-depth-reading`}>
      <div className="group py-4">
        <div className=" flex min-h-[118px] gap-3 bg-white px-3 py-4">
          <div className={cx(article.cover ? "flex-1" : "w-full")}>
            <h5 className="text-body-2 font-medium text-secondary">深入阅读</h5>
            <p className="mt-2 line-clamp-2 text-header-3 text-primary group-hover:underline">
              {article.title || ""}
            </p>
          </div>
          {article.cover && (
            <OptimisedImage
              rootClassName="!w-[140px] h-auto aspect-[3/2] group-hover:scale-105"
              src={article.cover} //element.cover
            />
          )}
        </div>
      </div>
    </Link>
  );
}
